import Vue from 'vue';

import BaseContainer from '@/components/base/BaseContainer';
import BaseCard from '@/components/base/BaseCard';
import BaseParagraph from '@/components/base/BaseParagraph';
import BaseSectionTitle from '@/components/base/BaseSectionTitle';
import BaseSocials from '@/components/base/BaseSocials';
import BaseLeaderCard from '@/components/base/BaseLeaderCard';
import BaseBackground from '@/components/base/BaseBackground';
import BaseEditor from '@/components/base/BaseEditor';

// The components are imported each for IDE support

// Components
Vue.component('BaseContainer', BaseContainer);
Vue.component('BaseCard', BaseCard);
Vue.component('BaseSocials', BaseSocials);
Vue.component('BaseLeaderCard', BaseLeaderCard);
Vue.component('BaseBackground', BaseBackground);
Vue.component('BaseEditor', BaseEditor);

// Texts
Vue.component('BaseParagraph', BaseParagraph);
Vue.component('BaseSectionTitle', BaseSectionTitle);
